var map = {
	"./badge_tick-dark.de.html": [
		560,
		560
	],
	"./badge_tick-dark.en.html": [
		580,
		580
	],
	"./badge_tick-dark.es.html": [
		991,
		991
	],
	"./badge_tick-dark.fr.html": [
		159,
		159
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 845;
module.exports = webpackAsyncContext;